<template>
    <div class="d-flex align-items-center" style="width: 100%">
        <model-select ref="select" :name="name" :isDisabled="isDisabled" :options="options" v-model="current_model" :placeholder="holder"
            :filterPredicate="equalsIgnoringCase">
        </model-select>
        <b-button v-b-tooltip.hover.top :title="btn_title" variant="success" @click="loadModal" v-if="modal"><i
                class="fas fa-plus"></i> {{ btn_text }}</b-button>
    </div>
</template>

<script>



import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
export default {
    name: "eSelect",
    props: {
        value: {
            default: "",
        },
        holder: { type: String, default: () => "Selecione" },
        custom_option: Object,
        reload: Boolean,
        name: String,
        route: String,
        modal: String,
        btn_title: String,
        btn_text: String,
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [{ value: "", text: "" }],
            current_model: this.value,
        };
    },
    components: {
        ModelSelect,
    },
    computed: {
        filterValue() {

            if (typeof this.value == "string") {
                let index = this.options.findIndex(item => {
                    return this.equalsIgnoringCase(item.value, this.value);
                });

                if (index == -1 && this.options[index] && this.options[index].value) {
                    return this.options[index].value;
                }
            }

            return this.value;

        }
    },
    watch: {
        reload(newVal) {
            if (newVal) {
                this.getOptions();

                /*SYNCRONIZAR*/
                let index;
                if (typeof newVal == 'string') {
                    /*SYNCRONIZAR*/
                    index = this.options.findIndex(item => {
                        return this.equalsIgnoringCase(item.value, this.value);
                    });
                } else {
                    index = this.options.findIndex(
                        (item) => item.data && item.value == this.value
                    );

                }


                if (index != -1 && this.options[index].data)
                    this.$emit("syncData", this.options[index].data);
            }
            /*END SYNCRONIZAR*/
        },
        route(newVal) {
            this.getOptions();
        },
        value(newVal) {
            this.current_model = newVal;

            if (newVal == "") {
                this.current_model = null;
                this.$refs.select.searchText = null;
            }

            let index;
            if (typeof newVal == 'string') {
                /*SYNCRONIZAR*/

                index = this.options.findIndex(item => {
                    return this.equalsIgnoringCase(item.value, this.value);
                });
            } else {
                index = this.options.findIndex(
                    (item) => item.data && item.value == this.value
                );

            }


            if (index != -1 && this.options[index].data) {

                this.$emit("syncData", this.options[index].data);

            } else if (index != 1 && this.options[index] && this.options[index].value) {
                this.current_model = this.options[index].value;
            }

            /*END SYNCRONIZAR*/

            if (!this.model && this.$refs.select && this.$refs.select.searchText) {
                this.$refs.select.searchText = null;
            }
        },
        current_model(currentValue) {
            if (currentValue != -1 || currentValue != "") {
                this.$emit("input", currentValue);
            }
        },
    },
    created() {
        this.$root.$emit("bv::hide::popover");
        this.getOptions();


    },
    methods: {
        async getOptions() {
            const result = await this.$api.get(this.route);

            let new_array = [];

            if (this.custom_option && this.custom_option.text != "") {
                new_array.push(this.custom_option);
            }

            if (result.data) {
                if (new_array.length) {
                    new_array = new_array.concat(result.data);
                    this.options = new_array;
                } else {
                    this.options = result.data;
                }
            }

            // this.$watch(
            //   () => {
            //     return this.$refs.select.searchText;
            //   },
            //   (val) => {
            //     this.$refs.select.searchText = "";
            //   }
            // );
        },
        loadModal() {
            this.$bvModal.show(this.modal);
        },

        equalsIgnoringCase(text, inputText) {

            if (typeof text === 'string' && typeof inputText === 'string') {
                text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                inputText = inputText.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                if (text.toLowerCase() === inputText.toLowerCase())
                    return true;

                if (text.toLowerCase().includes(" "+inputText.toLowerCase())) return true;


                if (text.toLowerCase().startsWith(inputText.toLowerCase())) return true;

                return false;
            }

            return text === inputText;

        }

    },
};
</script>
